export default {
    title: 'Components/USA Banner',
    tags: ['beta'],
  };
  
const Template = () => {
  return ` 
      <cbp-usa-banner>
      </cbp-usa-banner>
    `;
};

export const usabanner = Template.bind({});
usabanner.storyName="USA Banner"
